import React, { useState } from "react";
import { faFileAlt } from "@fortawesome/free-regular-svg-icons";
import { faArrowDown, faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dispatch } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../app";
import { FileProps } from "../../types/generic";
import "./styled.scss";

interface FilesDownloadProps {
  files: FileProps[];
  downloadFile: (file: FileProps) => (dispatch: Dispatch) => void;
  customClassName?: string;
}

export const FilesDownload: React.FC<FilesDownloadProps> = ({
  files,
  downloadFile,
  customClassName,
}: FilesDownloadProps) => {
  const dispatch = useDispatch<AppDispatch>();
  const [downloadingId, setDownloadingId] = useState(-1);

  const handleDownload = async (file: FileProps) => {
    setDownloadingId(file.attachment_id);
    await downloadFile(file)(dispatch);
    setDownloadingId(-1);
  };

  return (
    <div className={customClassName}>
      {files.length
        ? files.map((file) => (
            <div
              key={file.attachment_id}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.keyCode === 13 && handleDownload(file)}
              onClick={() => handleDownload(file)}
              className="files-download"
            >
              <FontAwesomeIcon icon={faFileAlt} size="1x" />
              {file.file_name}
              <FontAwesomeIcon
                icon={
                  downloadingId === file.attachment_id
                    ? faCircleNotch
                    : faArrowDown
                }
                spin={downloadingId === file.attachment_id}
                size="1x"
              />
            </div>
          ))
        : "-"}
    </div>
  );
};

export default FilesDownload;
